<template>
  <div class="row mt-3">
    <div class="col-lg-9" v-if="page == 1">
      <div class="card shadow-sm mb-5">
        <div class="card-body">
          <h5 class="d-flex justify-content-between">
            <b>Personal Information</b>
          </h5>

          <div class="d-flex justify-content-start mt-3">
            <div class="mt-4" style="">
              <h5>{{ subacct_name }}</h5>
              <h5>
                <b>{{ subacct_id }}</b>
              </h5>
              <h6>{{ subacct_email }}</h6>
              <h5>{{ subacct_telephone }}</h5>
            </div>
          </div>

          <!-- <h5 class="d-flex justify-content-between mt-5">
                        <b>Delivery Address</b>
                    </h5> -->

          <!-- <div class="row">
                        <div class="col-lg-6" v-for="(x,i) in addresses" :key="i">
                            <div class="card mt-3">
                                <div class="card-body" :class="freightedid == i ? 'active' : ''" @click="freightedid = i" style="min-height:120px">
                                    <div class="row">
                                        <div class="col-8">
                                            <b>{{subacct_name}}</b> - 
                                            <b>{{subacct_id}}</b>
                                        </div>
                                    </div>

                                    <p class="mt-2 font-12" style="font-weight: 500;">
                                        <span>{{x.street}}, {{x.city}}, {{x.state}}</span>
                                    </p>

                                    <div class="font-14"  style="font-weight: 500;">{{subacct_telephone}}</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
        </div>
      </div>
    </div>

    <!-- change password -->
    <div class="col-lg-9" v-if="page == 2">
      <div class="card shadow-sm">
        <div class="card-header">
          <b>Change Password</b>
        </div>
        <div class="card-body">
          <form
            class="login-form"
            autocomplete="off"
            method="post"
            v-on:submit.prevent="handlePassword"
          >
            <div class="row" v-if="password_screen == 0">
              <div class="col-lg-6">
                <div class="form-group">
                  <b>New Password:</b>
                  <div class="d-flex align-items-center">
                    <input
                      :type="showPass2 ? 'text' : 'password'"
                      class="form-control"
                      v-model="reset.password1"
                      required
                      placeholder="New Password"
                      minlength="8"
                      @keyup="CheckPassword(reset.password1)"
                    />
                    <i
                      :class="showPass2 ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      @click="showPass2 = !showPass2"
                      class="password-toggle-icon"
                    ></i>
                  </div>

                  <small
                    class="small-hint"
                    :class="
                      pass_stat == 'ok' ? 'text-success bolder' : 'text-danger'
                    "
                    >{{ pass_policy }}</small
                  >
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-group">
                  <b>Confirm New Password:</b>
                  <div class="d-flex align-items-center">
                    <input
                      :type="showPass3 ? 'text' : 'password'"
                      class="form-control"
                      v-model="reset.password2"
                      required
                      placeholder="Confirm Password"
                      minlength="8"
                    />
                    <i
                      :class="showPass3 ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      @click="showPass3 = !showPass3"
                      class="password-toggle-icon"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 offset-lg-3">
                <div :class="msg_status" v-html="msg_content"></div>
                <button
                  type="button"
                  class="btn form-control login-btn"
                  @click="checkOldPassword()"
                >
                  Update Password
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- change pin -->
    <div class="col-lg-9" v-if="page == 3">
      <div class="card shadow-sm">
        <div class="card-header">
          <b>Change Pin</b>
        </div>
        <div class="card-body">
          <form
            class="login-form"
            autocomplete="off"
            method="post"
            v-on:submit.prevent="handlePin"
          >
            <div class="row" v-if="otp_screen == 0">
              <div class="col-lg-6">
                <div class="form-group">
                  <b>New Pin:</b>
                  <div class="d-flex align-items-center">
                    <input
                      :type="showPin2 ? 'text' : 'password'"
                      class="form-control"
                      placeholder="Security PIN"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                      minlength="4"
                      maxlength="4"
                      v-model="pinreset.pin1"
                      required
                    />
                    <i
                      :class="showPin2 ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      @click="showPin2 = !showPin2"
                      class="password-toggle-icon"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="form-group">
                  <b>Confirm New Pin:</b>
                  <div class="d-flex align-items-center">
                    <input
                      :type="showPin3 ? 'text' : 'password'"
                      class="form-control"
                      placeholder="Confirm Security PIN"
                      oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                      minlength="4"
                      maxlength="4"
                      v-model="pinreset.pin2"
                      required
                    />
                    <i
                      :class="showPin3 ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      @click="showPin3 = !showPin3"
                      class="password-toggle-icon"
                    ></i>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 offset-lg-3">
                <div :class="msg_status1" v-html="msg_content1"></div>
                <button
                  type="button"
                  class="btn form-control login-btn"
                  @click="requestOTP()"
                >
                  Update PIN
                </button>
              </div>
            </div>

            <div class="row" v-if="otp_screen == 1">
              <div class="col-lg-12">
                <button @click="otp_screen = 0" class="btn btn-danger font-12">
                  <i class="fa fa-arrow-left"></i> &nbsp;&nbsp;&nbsp; Back
                </button>
              </div>

              <div class="col-lg-12 text-center mt-5">
                <p>
                  Please enter the OTP sent to your Phone and email address to
                  change your pin.
                </p>
              </div>
              <div class="col-lg-6  offset-lg-3 ">
                <div class="form-group">
                  <b>Enter OTP</b>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="OTP"
                    v-model="pinreset.otp"
                    required
                  />
                </div>
              </div>

              <div class="col-lg-6 offset-lg-3">
                <div :class="msg_status1" v-html="msg_content1"></div>
                <button
                  type="submit"
                  class="btn form-control login-btn"
                  :disabled="isDisabled1"
                >
                  {{ processBtn1 }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="col-lg-3">
      <div class="card shadow-sm" style="cursor:pointer;">
        <div class="card-header mb-1">
          <b>Links</b>
        </div>

        <!-- <p v-if="$route.name != 'ProfileView'" class="m-0" :class="page==1 ? 'bg-scope text-white bolder':''" style="padding:10px 10px 10px 20px; border-bottom:1px solid #f2f2f2" @click="page = 1"> View Profile </p> -->
        <p
          class="m-0"
          :class="page == 2 ? 'bg-scope text-white bolder' : ''"
          style="padding:10px 10px 10px 20px; border-bottom:1px solid #f2f2f2"
          @click="page = 2"
        >
          Change Password
        </p>
        <p
          class="m-0"
          :class="page == 3 ? 'bg-scope text-white bolder' : ''"
          style="padding:10px 10px 10px 20px; border-bottom:1px solid #f2f2f2"
          @click="page = 3"
        >
          Change Pin
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProfileComponent",
  components: {},

  data() {
    return {
      page_active: "profile",
      isDisabled: false,
      isDisabled1: false,

      processBtn: "Update Password",
      processBtn1: "Update Pin",

      msg_status: "",
      msg_content: "",

      msg_status1: "",
      msg_content1: "",
      showPass1: false,
      showPass2: false,
      showPass3: false,
      showPin1: false,
      showPin2: false,
      showPin3: false,

      vendor_no: "",

      pin_msg_content: "",
      reset: {
        password1: "",
        password2: "",
      },
      pinreset: {},
      pass_policy: "",
      pass_stat: "",

      addresses: [],
      page: 2,
      otp_screen: 0,
      password_screen: 0,
      freightedid: 0,
      subacct_name: "",
      subacct_id: "",
      subacct_email: "",
      subacct_telephone: "",
      passwordReset: {},
      otp: "",
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        document.title = "FMN | Edit Profile";
      },
    },
  },

  mounted() {
    this.vendor_no = this.$store.getters.vendor_no;
    let subprofiles = this.$store.getters.subaccounts;
    let sub_acct = subprofiles[0].customeraccount; //this.$store.getters.sub_acct;
    let subprofile_info = subprofiles.filter(
      (el) => el.customeraccount == sub_acct,
    );
    this.addresses = subprofile_info[0].addresses;
    this.subacct_telephone = subprofile_info[0].telephone;
    this.subacct_id = subprofile_info[0].customeraccount;
    this.subacct_name = subprofile_info[0].customername;
    this.subacct_email = subprofile_info[0].emailaddress;

    this.page = 2;
  },

  methods: {
    async handlePassword() {
      try {
        this.msg_status = "";
        this.msg_content = "";

        if (
          this.reset.password1 == this.reset.password2 &&
          this.pass_stat == "ok"
        ) {
          (this.isDisabled = true), (this.processBtn = "Processing...");

          this.reset.vendor_id = this.vendor_no;
          this.reset.newotp = this.otp;
          this.reset.subaccountID = this.$store.getters.subaccounts[0].customeraccount;

          let data = this.loadNew(this.reset);
          await axios({
            method: "post",
            url: this.$hostname + "/update-password",
            data: { token: data.cipher },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.getters.headerstoken}`,
              "X-Request-IV": data.iv,
            },
          })
            .then((res) => {
              this.response = res.data;
              if (this.response.status == true) {
                this.msg_status = "alert alert-success mt-4";
                this.msg_content = this.response.message;

                this.isDisabled = false;
                this.processBtn = "Update Password";

                this.$swal
                  .fire(
                    "Success Alert",
                    this.response.message ||
                      "Your password update was successful, you will redirected to login page.",
                    "success",
                  )
                  .then(() => {
                    setTimeout(() => {
                      this.$store.dispatch("logout");
                      this.$router.push("/");
                    }, 5000);
                  });
              } else {
                this.msg_status = "alert alert-danger mt-4";
                this.msg_content = this.response.message;
                this.isDisabled = false;
                this.processBtn = "Update Password";
              }
            })

            .catch((error) => {
              console.log(error);
              if (error.response.status === 401) {
                this.is401(error.response.status);
              }
            })

            .finally((e) => {
              this.isDisabled = false;
              this.processBtn = "Update Password";
              console.log(e);
            });
        } else {
          this.msg_status = "alert alert-danger mt-4";
          this.msg_content =
            "New Password & Confirm Password did not match or meet requirement.";
        }
      } catch (err) {
        this.msg_status = "alert alert-danger mt-4";
        this.msg_content = err;
      }
    },

    async checkOldPassword() {
      var loading_html = `
  <div style="display: flex; justify-content: center; align-items: center; height: 150px;">
    <div class="spinner-border" role="status" style="width: 4rem; height: 4rem; color: #006e40;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
`;
      this.$swal.fire({
        title: "",
        html: loading_html,
        showConfirmButton: false,
        showCancelButton: false,
      });
      try {
        this.msg_status = "";
        this.msg_content = "";

        if (
          this.reset.password1 == this.reset.password2 &&
          this.pass_stat == "ok"
        ) {
          this.passwordReset.vendor_id = this.vendor_no;

          let data = this.loadNew(this.passwordReset);
          await axios({
            method: "post",
            url: this.$hostname + "/request-password-update",
            data: { token: data.cipher },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.getters.headerstoken}`,
              "X-Request-IV": data.iv,
            },
          })
            .then((res) => {
              this.response = res.data;
              if (this.response.status == true) {
                this.$swal
                  .fire("Success Alert", this.response.message, "success")
                  .then(() => {
                    this.$swal
                      .fire({
                        title: "Verify with OTP",
                        text:
                          "Enter the 6-digit OTP sent to your registered phone and email.",
                        input: "text",
                        inputAttributes: {
                          autocapitalize: "off",
                          maxlength: 6,
                          placeholder: "000000",
                          pattern: "[0-9]{6}",
                        },
                        inputValidator: (value) => {
                          if (!value) {
                            return "OTP is required";
                          }
                          if (value.length !== 6) {
                            return "OTP must be exactly 6 digits";
                          }
                          if (!/^\d{6}$/.test(value)) {
                            return "OTP must contain only numbers";
                          }
                        },
                        confirmButtonText: "Verify OTP",
                        confirmButtonColor: "#006e40",
                        cancelButtonText: "Cancel",
                        showCancelButton: true,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                      })
                      .then((result) => {
                        if (result.isConfirmed && result.value) {
                          this.otp = result.value; // store the OTP value
                          this.handlePassword();
                        }
                      });
                  });
              } else {
                this.$swal.fire("Alert", res.data.message, "error");
              }
            })

            .catch((error) => {
              console.log(error);
              if (error.response.status === 401) {
                this.is401(error.response.status);
              }
            });
        } else {
          this.msg_status = "alert alert-danger mt-4";
          this.msg_content =
            "New Password & Confirm Password did not match or meet requirement.";
        }
      } catch (err) {
        this.msg_status = "alert alert-danger mt-4";
        this.msg_content = err;
      }
    },

    async handlePin() {
      try {
        this.msg_status1 = "";
        this.msg_content1 = "";

        if (
          this.pinreset.pin1 == this.pinreset.pin2 &&
          this.pinreset.pin1 != undefined
        ) {
          (this.isDisabled1 = true), (this.processBtn1 = "Processing...");

          this.pinreset.vendor_id = this.vendor_no;
          this.pinreset.subaccountID = this.$store.getters.subaccounts[0].customeraccount;

          let data = this.loadNew(this.pinreset);
          await axios({
            method: "post",
            url: this.$hostname + "/update-pin",
            data: { token: data.cipher },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.getters.headerstoken}`,
              "X-Request-IV": data.iv,
            },
          })
            .then((res) => {
              this.response = res.data;
              if (this.response.status == true) {
                this.msg_status1 = "alert alert-success mt-4";
                this.msg_content1 = this.response.message;

                this.isDisabled1 = false;
                this.processBtn1 = "Update Pin";

                this.$swal.fire(
                  "Success Alert",
                  this.response.message,
                  "success",
                );
                this.pinreset = {};

                // this.$router.push('/');
              } else {
                this.msg_status1 = "alert alert-danger mt-4";
                this.msg_content1 = this.response.message;
                this.isDisabled1 = false;
                this.processBtn1 = "Update Pin";
              }
            })

            .catch((error) => {
              console.log(error);
              if (error.response.status === 401) {
                this.is401(error.response.status);
              }
            })

            .finally((e) => {
              this.isDisabled1 = false;
              this.processBtn1 = "Update Pin";
              console.log(e);
            });
        } else {
          this.msg_status1 = "alert alert-danger mt-4";
          this.msg_content1 = "New Pin & Confirm Pin did not match.";
        }
      } catch (err) {
        this.msg_status1 = "alert alert-danger mt-4";
        this.msg_content1 = err;
      }
    },

    CheckPassword(x) {
      if (x.match(/^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,}$/)) {
        this.pass_policy = "Password strength: Strong";
        this.pass_stat = "ok";
      } else {
        this.pass_policy =
          "Minimum of 8 digits with 1 numeric and 1 special character.";
        this.pass_stat = "";
      }
    },

    requestOTP() {
      var loading_html = `
  <div style="display: flex; justify-content: center; align-items: center; height: 150px;">
    <div class="spinner-border" role="status" style="width: 4rem; height: 4rem; color: #006e40;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
`;
      this.$swal.fire({
        title: "",
        html: loading_html,
        showConfirmButton: false,
        showCancelButton: false,
      });
      try {
        this.msg_status1 = "";
        this.msg_content1 = "";

        if (
          this.pinreset.pin1 == this.pinreset.pin2 &&
          this.pinreset.pin1 != undefined &&
          this.pinreset.oldpin != undefined
        ) {
          this.pinreset.vendor_id = this.vendor_no;
          // this.pinreset.subaccountID = this.$store.getters.subaccounts[0].customeraccount;
          this.pinreset.subaccountID = this.vendor_no;

          console.log("subaccountID:", this.pinreset.subaccountID);
          console.log("vendor_id:", this.pinreset.vendor_id);
          console.log("vendor_id2:", this.$store.getters.sub_acct);

          let data = this.loadNew(this.pinreset);
          axios({
            method: "post",
            url: this.$hostname + "/request-pin-otp",
            data: { token: data.cipher },
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.$store.getters.headerstoken}`,
              "X-Request-IV": data.iv,
            },
          })
            .then((res) => {
              let response = res.data;

              if (response.status == true) {
                this.otp_screen = 1;

                this.$swal.fire("Success Alert", response.message, "success");
              } else {
                if (response.reset) {
                  this.$swal
                    .fire("Alert", response.message, "error")
                    .then((okay) => {
                      if (okay) {
                        window.location.href = "/reset-pin";
                      }
                    });
                } else {
                  this.$swal.fire("Alert", response.message, "error");
                }
              }
            })

            .catch((error) => {
              console.log(error);
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
              if (error.response.status === 401) {
                this.is401(error.response.status);
              }
            })

            .finally((e) => {
              console.log(e);
            });
        } else {
          this.msg_status1 = "alert alert-danger mt-4";
          this.msg_content1 = "New Pin & Confirm Pin did not match.";
        }
      } catch (err) {
        this.msg_status = "alert alert-danger mt-4";
        this.msg_content = err;
      }
    },
  },
};
</script>

<style scoped>
.login-form input.form-control,
.select {
  margin: 0 0 20px 0px;
}
</style>
